/* import __COLOCATED_TEMPLATE__ from './onboarding.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { getOnboardingHeroImageUrl } from '@banking/ui/utils/checking-image-urls';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import { inject as service } from '@ember/service';
const htmlSafeTranslate = intl => key => intl.t(key, {
  htmlSafe: true
});
const CHECKING_AND_DEBIT_VALUE_PROPS = [{
  svgJarName: '24px-timer',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.simple.l1', 'banking.checking.onboarding.marketing.valueProp.checkingAndDebit.simple.l2']
}, {
  svgJarName: '24px-bolt',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.instantAccess']
}, {
  svgJarName: '24px-switch-horizontal',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.payBills']
}, {
  svgJarName: '24px-happy',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.fees.l1', 'banking.checking.onboarding.marketing.valueProp.checkingAndDebit.fees.l2']
}];
const SQUARE_CARD_VALUE_PROPS = [{
  svgJarName: '24px-timer',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.simple']
}, {
  svgJarName: '24px-bolt',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.instantAccess']
}, {
  svgJarName: '24px-store-stroked',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.separation']
}, {
  svgJarName: '24px-happy',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.fees.l1', 'banking.checking.onboarding.marketing.valueProp.squareCard.fees.l2']
}];
const getValueProps = intl => productName => (() => {
  switch (productName) {
    case ProductName.CheckingAndDebit:
      return CHECKING_AND_DEBIT_VALUE_PROPS;
    case ProductName.SquareCard:
      return SQUARE_CARD_VALUE_PROPS;
    case ProductName.None:
      throw new Error('ProductName.None is not supported');
  }
})().map(valueProp => ({
  ...valueProp,
  lines: valueProp.lines.map(htmlSafeTranslate(intl))
}));
let OnboardingUpsell = (_class = class OnboardingUpsell extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "assetMap", _descriptor3, this);
  }
  get heroImageUrl() {
    const countryAlphaCode = this.userInfo.countryCode;
    return this.assetMap.resolve(getOnboardingHeroImageUrl(countryAlphaCode));
  }
  get heroImageAlt() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.marketing.heroAlt'));
  }
  get head() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.marketing.head'));
  }
  get cta() {
    return this.intl.t('banking.checking.onboarding.marketing.cta');
  }
  get subhead() {
    return this.intl.t('banking.checking.onboarding.marketing.subhead');
  }
  get valueProps() {
    return getValueProps(this.intl)(this.args.productName);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { OnboardingUpsell as default };